import React from 'react';
import CensusMap from '../Common/CensusMap';
import { useCensusFiltersContext } from '../Common/Filters/hooks/useCensusFiltersContext';
import OverviewCards from './OverviewCards';

const residentsOf = tract => tract.residents;

// Painel da área selecionada: os mesmos cartões do Panorama Básico, somados nos setores da área.
const BasicSector = () => {
    const { filters } = useCensusFiltersContext();
    const cityId = filters.cidade?.value;
    const year = filters.year?.value;

    return (
        <CensusMap
            cityId={cityId}
            year={year}
            valueOf={residentsOf}
            metricLabel="moradores"
            renderPanel={selection => (
                <OverviewCards
                    cityId={cityId}
                    year={year}
                    sectorIds={selection.isCity ? null : selection.tracts.map(tract => tract.id)}
                />
            )}
        />
    );
};

export default BasicSector;
